<template>
  <main class="container">
    <slot name="nav" />
    
    <div class="layout">
      <slot />
    </div>
  </main>
</template>

<style scoped lang="scss">
  .container {
    height: inherit;
  }

  .layout {
    position: relative;
    max-width: 1260px;
    height: auto;
    margin: 0 auto;
    padding: 0 20px 20px;
  }
</style>

<script>
  export default {
    name: 'Blank',
  };
</script>